import { Button } from '@material-ui/core';
import React from 'react';
/** Shown in the panel body when the assistant runs into an error. */
export const ErrorState = ({ onRetry }) => (React.createElement("div", { className: "ai-assistant__status", role: "alert" },
    React.createElement("p", { className: "ai-assistant__status-text" }, "Something went wrong with the assistant."),
    onRetry && (React.createElement(Button, { color: "primary", onClick: onRetry, variant: "outlined" }, "Try again"))));
